import React from "react";
import { Box } from "@mui/material";

const CustomLegend = ({ totalStats, colors, selectedYAxis }) => {
  return (
    <Box
      className="item-flex"
      mt="20px"
      sx={{ flexWrap: "nowrap", overflow: "hidden" }}
    >
      {totalStats.map((item, index) => {
        const colorIndex = selectedYAxis.indexOf(item.key);
        const bgColor = colorIndex !== -1 ? colors[colorIndex] : "#D3D3D3";

        return (
          <Box key={item.title} mr="32px">
            <Box
              className="item-flex"
              mb="6px"
              sx={{ flexWrap: "nowrap", whiteSpace: "nowrap" }}
            >
              <Box
                bgcolor={bgColor}
                height="8px"
                width="12px"
                borderRadius="2px"
                mr="4px"
              />
              <Box
                fontSize={12}
                fontWeight={400}
                color="#777"
                sx={{ whiteSpace: "nowrap" }}
              >
                {item.title}
              </Box>
            </Box>
            <Box fontSize={18} fontWeight={700} color="#555" pl="16px">
              {item?.value?.toLocaleString()}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default CustomLegend;
